module.exports = __webpack_public_path__ + "static/img/activity@2x.b50930c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/home/activity@2x.png
// module id = ETGn
// module chunks = 1